import { Link } from 'react-router-dom';
import { categoryInfo, categoryHeaderImages } from '@/mocks/category';

interface CategoryHeaderProps {
  slug: string;
}

const categoryTabs = [
  { slug: 'lian-ai', label: '恋爱' },
  { slug: 'qi-huan', label: '奇幻' },
  { slug: 'dong-zuo', label: '动作' },
  { slug: 'ju-qing', label: '剧情' },
  { slug: 'chong-sheng', label: '重生' },
  { slug: 'gao-xiao', label: '搞笑' },
  { slug: 'xuan-yi', label: '悬疑' },
  { slug: 'gu-feng', label: '古风' },
];

export default function CategoryHeader({ slug }: CategoryHeaderProps) {
  const info = categoryInfo[slug];
  if (!info) return null;

  return (
    <section className="relative w-full bg-gradient-to-b from-[#3b2d24] to-[#2a1f18] pt-10 pb-0 overflow-hidden">
      {/* Tab Switcher */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 mb-8">
        <div className="flex items-center gap-1 overflow-x-auto pb-2 scrollbar-hide">
          {categoryTabs.map((tab) => (
            <Link
              key={tab.slug}
              to={`/category/${tab.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                slug === tab.slug
                  ? 'bg-accent-500 text-white'
                  : 'text-white/60 hover:text-white hover:bg-white/10'
              }`}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 pb-16 md:pb-24">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-3/5">
            <span className="inline-block px-3 py-1 bg-accent-100/20 text-accent-300 rounded-md text-xs font-medium mb-4">
              &middot; 分类浏览 &middot;
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
              {info.name}分类
            </h1>
            <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-xl">
              {info.description}
            </p>
          </div>

          <div className="lg:w-2/5 flex items-start gap-6">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-lg overflow-hidden flex-shrink-0">
              <img
                src={categoryHeaderImages[slug]}
                alt={info.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <span className="font-heading text-5xl md:text-7xl font-bold text-white/90 block leading-none">
                {info.count.toLocaleString()}+
              </span>
              <p className="text-white/50 text-sm mt-2">部漫画作品</p>
              <p className="text-white/40 text-xs mt-1">无删减高清画质</p>
              <p className="text-white/40 text-xs">下拉式流畅阅读</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}